module.exports = {"150102001":"海拉尔东路街道","150102002":"锡林路街道","150102003":"中山东路街道","150102004":"东街街道","150102005":"西街街道","150102006":"东风路街道","150102007":"迎新路街道","150102008":"成吉思汗大街街道","150102101":"保合少镇","150102400":"新城区鸿盛高科技园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150102.json
// module id = 349
// module chunks = 0